import { IStore } from '../index'

export default function(store: IStore) {
  return store.notificationsService
}
